// =====================================================
// API — Timeline de actividad del paciente
// =====================================================
import { api } from './client';
import type { TimelineEvent, TimelineEventType } from '../types/patient';

export interface TimelineQuery {
  types?: TimelineEventType[];
  allSites?: boolean;
  cursor?: string | null;
  limit?: number;
}

export interface TimelineResponse {
  events: TimelineEvent[];
  hasMore: boolean;
  nextCursor: string | null;
}

export const patientTimelineApi = {
  getTimeline: (patientId: string, query: TimelineQuery = {}): Promise<TimelineResponse> => {
    const params = new URLSearchParams();
    if (query.types && query.types.length > 0) params.append('types', query.types.join(','));
    if (query.allSites) params.append('allSites', 'true');
    if (query.cursor) params.append('cursor', query.cursor);
    if (query.limit) params.append('limit', String(query.limit));
    const qs = params.toString();
    return api.get(`/patient-timeline/${patientId}${qs ? '?' + qs : ''}`);
  },
};
